export default "/images/vendor/flag-icons/flags/1x1/gl.svg?2466f7b0c1cdbbc5bce5bb00920365df";